import React, { useEffect, useState } from 'react';
import AdminAppBar from '../adminComponents/AdminAppBar';
import { useNavigate } from "react-router-dom";
import AppBar from '../leadComponent/AppBar';

const MyProfile = () => {
  const [userData, setUserData] = useState({});
  const [teamData, setTeamData] = useState([]);

  
  useEffect(() => {
    // Log local storage content before parsing
    console.log('Local Storage - userData:', localStorage.getItem('userData'));

    const storedUserData = localStorage.getItem('userData');

    if (storedUserData) {
      const parsedUserData = JSON.parse(storedUserData);
      console.log('Parsed User Data:', parsedUserData);
      setUserData(parsedUserData.user);
      setTeamData(parsedUserData.teamId || []);
    }
  }, []);

  

  useEffect(() => {
    console.log('Updated Team Data State:', teamData);
  }, [teamData]);

  const teamNames = teamData.map(team => team.name).join(', ');
  return (
    <div className=' bg-appGrayBackground pt-16 pb-10'>
      {(userData.role == "Admin" ||userData.role == "MD" || userData.role == "BOD" || userData.role === "CMO"  )? <AdminAppBar/> : <AppBar/> }
      

      <div>
        <div className="bg-appGrayBackground">
          

          

          <div className="flex items-center gap-7    mt-10">
          <div className=" ">
      
          </div>
          <div className="text-3xl font-bold mt-1 4xl:text-4xl ">
            Your Profile
          </div>
        </div>
           

        {/* 4xl:w-full 4xl:h-[650px] w-full  shadow-md rounded flex flex-col gap-6 3xl:w-10/12  md:px-4 lg:px-8 lg:pt-7 md:pt-6 md:pb-4 lg:pb-8 md:mt-8 lg:mt-8 md:mx-0 lg:mx-0 md:mb-4  */}

            <form className="bg-white   shadow-md rounded flex flex-col gap-6 p-12 mx-16 mt-6 4xl:mt-20 4xl:h-[760px]">
              <div className="mb-8 flex items-center 4xl:mt-16">
                <label className="w-1/4 text-gray-700 text-2xl  4xl:text-3xl  font-medium" htmlFor="name">
                  User Name
                </label>
                <input
                  className="shadow appearance-none border rounded  4xl:text-3xl  w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="name"
                  type="text"
                  value={userData.name || ''}
                  readOnly
                />
              </div>

              <div className="mb-8 flex items-center">
                <label className="w-1/4 text-gray-700 text-2xl 4xl:text-3xl  font-medium" htmlFor="role">
                  Role
                </label>
                <input
                  className="shadow appearance-none border rounded 4xl:text-3xl  w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="role"
                  type="text"
                  value={userData.role || ''}
                  readOnly
                />
              </div>

              {userData.role !== 'Admin' && (
                <div className="mb-8 flex items-center">
                  <label className="w-1/4 text-gray-700 text-2xl 4xl:text-3xl  font-medium" htmlFor="team">
                    Team
                  </label>
                  <div className="shadow appearance-none border 4xl:text-2xl  rounded h-10 w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline">
                  {teamData.length > 0 ? (
                      <div>{teamNames}</div>
                    ) : (
                      <div>No team  available</div>
                    )}


                  </div>
                </div>
              )}

              <div className="mb-8 flex items-center">
                <label className="w-1/4 text-gray-700 text-2xl 4xl:text-3xl  font-medium" htmlFor="employeeId">
                  Employee ID
                </label>
                <input
                  className="shadow appearance-none border rounded  4xl:text-3xl  w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="employeeId"
                  type="text"
                  value={userData.employeeId || ''}
                  readOnly
                />
              </div>

              <div className="mb-8 flex items-center">
                <label className="w-1/4 text-gray-700 text-2xl 4xl:text-3xl  font-medium" htmlFor="emailId">
                  Email ID
                </label>
                <input
                  className="shadow appearance-none border rounded 4xl:text-3xl  w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="emailId"
                  type="text"
                  value={userData.emailId || ''}
                  readOnly
                />
              </div>

              <div className="mb-8 flex items-center">
                <label className="w-1/4 text-gray-700 text-2xl 4xl:text-3xl  font-medium" htmlFor="phoneNumber">
                  Phone Number
                </label>
                <input
                  className="shadow appearance-none border rounded 4xl:text-3xl  w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="phoneNumber"
                  type="text"
                  value={userData.phoneNumber || ''}
                  readOnly
                />
              </div>
            </form>
          </div>
        </div>
      </div>
  );
};

export default MyProfile;
